
    <div class=" mt-4" >
        <section class="my-4">
      

  <div class="scrollmenu">
    <!-- <a [routerLink]="['/PayOut/AccountBalance']">Account Balance</a> -->
      <!-- <a  [routerLink]="['/PayOut/ManagePayOutContact']">PayOut
        Contact</a> -->
        <!-- <a [routerLink]="['/PayOut/BeneficiaryList']">PayOut Beneficiary</a> -->

      <!-- <a [routerLink]="['/PayOut/PayoutLedgers']">PayOut Ledger</a> -->
      <!-- <a [routerLink]="['/PayOut/PayOutTransactions']">PayOut Transaction</a> -->
      <!-- <a [routerLink]="['/PayOut/PayOutBatches']">PayOut settlement</a> -->
      <!-- <a [routerLink]="['/PayOut/managePayoutAccountdetails']">Payout Security</a> -->
      <!-- <a [routerLink]="['/PayOut/ManagePayOutBulkUploadFiles']">Bulk File Upload</a> -->
      <a [routerLink]="['/PayOut/PayoutReports']">Payout Reports</a>
      <a class="active menu" [routerLink]="['/PayOut/PayoutPostback']">PayOut Webhook Url</a>
      <a [routerLink]="['/PayOut/Payoutwebhookdata']">PayOut Webhook Data</a>
      <a [routerLink]="['/PayOut/PayoutLedger']">PayOut Ledger</a>
      <!-- <a [routerLink]="['/PayOut/PayoutReports']">Reports</a> 
      <a [routerLink]="['/PayOut/PayoutSecurityTransactions']">Payout Security Transactions</a>
     <a [routerLink]="['/settings/ChargeBack']">ChargeBack</a> -->
  </div>
</section>
</div>
<section class="mt-3">
<div class="" >
    <div class="row"> 
        <div class="col-md-7" *ngIf="Addata">
            <div class="card-1">
               
                <form #fnewinvoice="ngForm">
                    <div class="form-group mb-0  ">
                        <div class="row pt-2">
                          
                            <div class="col-lg-12">
                               
                                <div class="form-group formgroup-tm">
                                    <label class="customlabel">PayOut PostBack Url*</label>
                                    <input type="text" class="formcontrol-user1 form-control" placeholder="PayOut PostBack Url"
                                        id="PayOutPostBackUrl" name="PayOutPostBackUrl"
                                        [formControl]="PayOutPostBackUrl" [(ngModel)]="PostBackUrl"  required  (focus)="isPayOutPostBackUrlHidden = false" (blur)="isPayOutPostBackUrlHidden = true"  [ngClass]="{ 'is-invalid': PayOutPostBackUrl.touched && PayOutPostBackUrl.invalid }">
                                </div>
                                
                            </div>
                        </div> 
                        <div class="row pt-2">
                            <div class="col-lg-12">
                                
                                <div class="form-group formgroup-tm">
                                    <label class="customlabel">PayOut PostBack AuthKey</label>
                                    <input type="text" class="formcontrol-user1 form-control"  placeholder="PayOut PostBack AuthKey" id="PayOutPostBackAuthKey"
                                        name="PayOutPostBackAuthKey" [formControl]="PayOutPostBackAuthKey" [(ngModel)]="AuthKey"  (focus)="isPayOutPostBackAuthKeyHidden = false" (blur)="isPayOutPostBackAuthKeyHidden = true"  [ngClass]="{ 'is-invalid': PayOutPostBackAuthKey.touched && PayOutPostBackAuthKey.invalid }">
                                </div>
                                <!-- <span class="text-danger"
                                    *ngIf="OrderPostBackAuthKey.invalid && (OrderPostBackAuthKey.dirty || OrderPostBackAuthKey.touched)">{{OrderPostBackAuthKeyerrors()}}
                                </span> -->
                            </div>
                        </div>
                       
                            
                         
                        <div class="  pt-3">
                           
                            <button  class="btn dash-btns" [disabled]="PayOutPostBackUrl.invalid"  color="primary" (click)="savepostbackurl()" >Proceed Now</button>
                           
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="col-md-7" *ngIf="viewdetail">
            <div class=" card-1">
                <div class="row mb-3">
                    <div class="col-3 p-0">
                        <label>PayOut PostBack Url:</label>
                    </div>
      
                    <div class="col-9 p-0 view-text">{{PostBackUrl}}</div>
                </div>
                <div class="row mb-3">
      
                    <div class="col-3 p-0">
                        <label>PayOut PostBack AuthKey:</label>
                    </div>
      
                    <div class="col-9 p-0 view-text">{{AuthKey}}</div>
      
                </div>
            
                <div class="text-right py-2" *ngIf="Editpostbackurl">
                          
                  <button class="btn dash-btns" type="button" id="Businessinfoview" color="primary"
                    (click)="Updatedetails()">Edit</button>
             
                    <button class="dash-btns ml-3" type="button" id="Businessinfoview" color="primary"
                    (click)="redirecttoreportswebhookdata()">Payout Webhook Data</button>
    
                </div>
               
        
            </div>
        </div>
        <div class="col-md-5">
            <div class="card-1 p-2">
                <div class="text-center">
                    <!-- <img src="assets/img/new/invoices.gif" /> -->
                    <div *ngIf="!isimgHidden">
                        <img src="https://fastswiff.com/assets/img/vpos-tour-images/payout/manage-payout.png" class="w-100" alt="">
                    </div>
                </div>
      
                <div class="row">
                    <div class="col-md-12">
                        <div class="p-4">
                            <div class="alert alert-info" id="another-div" *ngIf="!isPayOutPostBackUrlHidden">
                                 Enter Your PostBackUrl
                            </div>
                            <div class="alert alert-info" id="another-div" *ngIf="!isPayOutPostBackAuthKeyHidden">   Enter Your is PayOut PostBack AuthKey  </div> 
                           
                            <div> 
                                <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"   *ngIf="PayOutPostBackUrl.invalid && (PayOutPostBackUrl.dirty || PayOutPostBackUrl.touched)">{{PayOutPostBackUrlerrors()}}</div>                                  
                            </div> 
      
                        </div>
                    </div>
      
                </div>
            </div>
        </div>
    </div>
</div>




<div class="row" >

</div>




</section>






